@if (rlnIcon) {
  <svg-icon class="fill-current" src="assets/icons/{{ rlnIcon }}.svg"></svg-icon>
}

@if (matIcon) {
  <mat-icon class="size-6 text-lg" [ngClass]="matIconOutlined ? 'material-icons-outlined' : 'material-icons'"> {{ matIcon }} </mat-icon>
}
